export default __webpack_public_path__ + "static/media/arch-logo.a2f21ca7.svg";